module.exports = {"id":"153275","name":"Jean-Louis Leca","rating":"73","photo":"./data/images/photos/3/153275.png","club":{"name":"AC Ajaccio","logo":"./data/images/clubs/ACAjaccio.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Jean-LouisLeca0.json
// module id = 1955
// module chunks = 0